import moment from 'moment'
import { TransactionReportType } from 'src/components/ReportTransactionsBoxAndLinks/reportTypes'
import { makeBaseTransactionsSchema } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import {
  TransactionDateType,
  TransactionReceiptRecoveryStatus,
  TransactionSort,
} from 'src/models/transaction.models'
import { accountingReviewReportsUrl } from 'src/navigation/urls'

interface AccountingPeriodBounds {
  readonly localStartDate: string
  readonly localEndDate: string
}

export const getReceiptRecoveryTransactionsUrl = (
  status: TransactionReceiptRecoveryStatus,
  period: AccountingPeriodBounds,
): string => {
  const filters = makeBaseTransactionsSchema({
    context: TransactionReportType.AccountingTransactions,
    expenseCategories: [],
    sort: TransactionSort.dateClearDesc,
  })
  const query = filters.stringifyFilters({
    dateType: TransactionDateType.Clear,
    receiptRecoveryStatus: new Set([status]),
    since: moment(period.localStartDate),
    until: moment(period.localEndDate).subtract(1, 'day'),
  })

  return `${accountingReviewReportsUrl()}?${query}`
}
